import { useContext } from 'react'
import { ErrorHandlerContext } from '@/contexts/ErrorHandlerContext'

export const useErrorHandlerContext = () => {
  const context = useContext(ErrorHandlerContext)

  if (!context) throw new Error('useErrorHandler hook have to be wrapped by ErrorHandlerContextProvider');
  
  return context;
};